import {themr} from '@friendsofreactjs/react-css-themr';

import identifiers from '../identifiers';
import Icon from './icon';

import style from './style.module.css';

export default themr(identifiers.icon, style)(Icon);
